import { defaultDictionaryValueMissing } from '../repository';

export type AuthenticationKey = 'Close' | 'LogOut' | 'YouAreAuthenticated' | 'YouAreNotAuthenticated';

export const getDefaultAuthenticationValue = (key: AuthenticationKey): string => {
	switch (key) {
		case 'Close':
			return 'Luk';
		case 'LogOut':
			return 'Log ud';
		case 'YouAreAuthenticated':
			return 'Du er logget ind';
		case 'YouAreNotAuthenticated':
			return 'Du er ikke logget ind';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
